// extracted by mini-css-extract-plugin
export default {"root":"PreviewRoll-styles-module--root--nGypY","container":"PreviewRoll-styles-module--container--iDY0N","item":"PreviewRoll-styles-module--item--yu666"};